import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import SyncReports from "@/pages/SyncReports";
import Documents from "@/pages/Documents";
import ApiKeys from "@/pages/ApiKeys";
import Alerts from "@/pages/Alerts";
import AdminAccess from "@/pages/AdminAccess";
import { AdminLayout } from "@/components/AdminLayout";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500 font-mono text-xs" data-testid="auth-loading">VERIFYING SESSION…</div>;
  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Navigate to="/sync-reports" replace />} />
            <Route path="sync-reports" element={<SyncReports />} />
            <Route path="documents" element={<Documents />} />
            <Route path="keys" element={<ApiKeys />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="admins" element={<AdminAccess />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
